import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, computed } from "vue";
import { filterAccountableAccounts } from "../../../../backend/src/common/accountableAccount/accountableAccountServices";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'ossAccountableAccountSelector',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    accountableAccountNames: {},
    selected: {},
    companyId: {}
  }, {
    "modelValue": { type: Boolean, ...{
    default: false,
} },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["close", "select"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const dialog = _useModel<boolean>(__props, "modelValue");

const props = __props;

const emits = __emit;

const store = useStore();

const internalSelected = ref(props.selected);
const accountableAccountTable = store.state.accountableAccountTable;
debugger;

const inSelected = computed<string>({
    get: () => internalSelected.value || props.selected,
    set: (value: string) => {
        internalSelected.value = value;
    },
});

const selectItem = (item) => (inSelected.value = item.name);

const emitCloseDialog = () => emits("close");

const getItemClass = (itemName) => {
    let itemClass = "oss-list-item mb-2";
    if (itemName === inSelected.value) {
        itemClass += " oss-list-item-selected";
    }
    return itemClass;
};

const accountableAccounts = computed(() =>
    filterAccountableAccounts(accountableAccountTable.value, props.accountableAccountNames),
);

const showRemove = computed<boolean>(() => {
    if (!props.selected) return false;
    return props.accountableAccountNames.find((aan) => aan === props.selected);
});

const validDisabled = computed<boolean>(() => {
    if (!inSelected.value) return true;
    if (inSelected.value === props.selected) return true;
    return false;
});

const isSelected = (item) => {
    if (!inSelected.value) {
        return false;
    }
    return item.name === inSelected.value;
};

const setItem = () => {
    emits("select", inSelected.value);
    emitCloseDialog();
    inSelected.value = "";
    dialog.value = true;
};

const remove = () => {
    emits("select", "");
    dialog.value = true;
    emitCloseDialog();
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
    title: _ctx.title,
    width: "800px",
    onClose: emitCloseDialog
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          (showRemove.value)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "rounded-lg gradient",
                    rounded: "",
                    block: "",
                    elevation: "0",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (remove())),
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Retirer")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: showRemove.value ? 6 : 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "rounded-lg gradient",
                rounded: "",
                block: "",
                elevation: "0",
                disabled: validDisabled.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setItem())),
                size: "x-large"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Valider")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_1, "Compte comptable actuel : " + _toDisplayString(_ctx.selected), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_list, {
        "two-line": "",
        subheader: "",
        style: {"background-color":"transaparent","height":"30vh","overflow":"scroll"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountableAccounts.value, (item) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: item.name,
              class: _normalizeClass(getItemClass(item.name)),
              onClick: ($event: any) => (selectItem(item))
            }, _createSlots({
              append: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: isSelected(item) ? 'secondary' : 'primary',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(isSelected(item) ? "$oss-circle-check" : "$oss-circle-uncheck"), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.description), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, [
              (item.subAccountableAccountOf)
                ? {
                    name: "prepend",
                    fn: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("$subdirectory_arrow_right")
                        ])),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["class", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})